<!--
 * @Author: kztai 1012049531@qq.com
 * @Date: 2022-06-08 19:48:37
 * @LastEditors: kztai 1012049531@qq.com
 * @LastEditTime: 2022-06-23 19:01:01
 * @FilePath: \vue-cli\src\components\dialogWrap.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->

<template>
  <transition name="wtc-dialog-fade">
    <div class="wtc-dialog-wrap" @click="toggleWrap" v-show="showWrap">
      <slot></slot>
    </div>
  </transition>
</template>

<script>
export default {
  name: "dialogWrap",
  props: ['showWrap'],

  data() {
    return {
    };
  },

  mounted() {
    this.$nextTick(() => {
      const body = document.querySelector("body");
      if (body.append) {
        body.append(this.$el);
      } else {
        body.appendChild(this.$el);
      }
    });
  },

  methods: {
    toggleWrap() {
      this.$emit('hideDialog');
    }
  }
};
</script>

<style scoped>
.wtc-dialog-wrap {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  opacity: 1;
  z-index: 9999;
  -webkit-transform:translateZ(1px);
  -moz-transform:translateZ(1px);
  -o-transform:translateZ(1px);
  transform:translateZ(1px);
}

.wtc-dialog-fade-enter-active,
.wtc-dialog-fade-leave-active {
  transition: opacity .5s;
}

.wtc-dialog-fade-enter,
.wtc-dialog-fade-leave-to {
  opacity: 0
}
</style>